import * as React from 'react';

import {StackLegacy} from '../layout/stack/stack-legacy';
import {BoldLabel} from '../typography/bold-label';

type Props = {
    icon: React.ComponentType<any>;
    label: string;
    alignCenter?: boolean;
};

export function OrderLabel(props: Props) {
    const Icon = props.icon;

    // If we use an old icon, we can't pass alignCenter as a prop without a console
    // error, so we only pass it if needed
    const iconProps = props.alignCenter ? {alignCenter: true} : {};

    return (
        <div className='mb-8'>
            <BoldLabel>
                <StackLegacy spacing={6} isHorizontal={true} alignCenter={true}>
                    <Icon size={15} {...iconProps} />
                    <div>{props.label}</div>
                </StackLegacy>
            </BoldLabel>
        </div>
    );
}
